// import { Link } from "react-router-dom";
// import PageBanner from "./PageBanner";
// import SectionHeader from "./SectionHeader";
// import React from "react";
// import {
//   FaBarcode,
//   FaMicrochip,
//   FaChartLine,
//   FaTv,
//   FaRecycle,
// } from "react-icons/fa";
// import SocialMediaSidebar from "./SocialMediaSidebar";

// const TermsConditions = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Terms & Conditions"
//         breadcrumb={[
//           { label: "Terms & Conditions", href: "/" },
//           //   { label: "About Us" },
//           //   { label: "Story" },
//         ]}
//       />

//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Terms & Conditions @ AJEEVI"
//           shareUrl="https://your-site.com/smart-waste"
//         />
//       </div>

//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//     {/* Header Section */}
//     <div className="mb-10">
//       <h1 className="text-3xl font-bold text-black mb-2">Terms of Use</h1>
//       <p className="text-lg text-black mb-4">
//         <strong>Effective Date:</strong> 17-06-2025<br />
//         <strong>Platform:</strong> ParkAJV<br />
//         <strong>Operated By:</strong> Ajeevi Technologies Pvt. Ltd.
//       </p>
//     </div>

//     {/* Welcome Statement */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">Welcome Statement</h4>
//       <p className="text-black mb-4 text-lg">
//         Welcome to <strong>ParkAJV</strong>, an AI-powered parking management platform developed by Ajeevi Technologies Pvt. Ltd. Our solution optimizes <strong>Multi-Level Car Parks (MLCP), on-street, and off-street parking</strong> through real-time monitoring, automated payments, and data-driven operations.
//       </p>
//       <p className="text-black text-lg">
//         These Terms govern your access to ParkAJV's mobile/web apps, IoT parking sensors, and license plate recognition (LPR) systems. By using ParkAJV, you agree to comply with these terms and all applicable laws.
//       </p>
//     </div>

//     {/* Purpose of the Platform */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">1. Purpose of the Platform</h4>
//       <p className="text-black mb-4 text-lg">
//         ParkAJV is designed to:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Enable <strong>real-time parking slot availability</strong> via IoT sensors and LPR cameras</li>
//         <li>Facilitate <strong>contactless payments</strong> (UPI/cards/cashless)</li>
//         <li>Optimize <strong>dynamic pricing</strong> based on demand and peak hours</li>
//         <li>Provide <strong>municipal authorities</strong> with occupancy analytics</li>
//         <li>Reduce urban congestion through <strong>guided parking navigation</strong></li>
//       </ul>
//     </div>

//     {/* Eligibility and Access */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">2. Eligibility and Access</h4>
      
//       <h5 className="text-xl font-semibold mb-3 text-black">2.1 Authorized Users</h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li><strong>Drivers:</strong> Individuals parking in partnered facilities</li>
//         <li><strong>Operators:</strong> Parking lot owners/managers</li>
//         <li><strong>Municipal Staff:</strong> Traffic/parking enforcement officers</li>
//       </ul>

//       <h5 className="text-xl font-semibold mb-3 text-black">2.2 Restricted Activities</h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>Tampering with sensors/LPR cameras</li>
//         <li>Using fake/duplicate license plates</li>
//         <li>Reselling parking slots commercially</li>
//       </ul>
//     </div>

//     {/* User Responsibilities */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">3. User Responsibilities</h4>
      
//       <h5 className="text-xl font-semibold mb-3 text-black">3.1 Vehicle Operators Must:</h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Ensure license plates are clearly visible</li>
//         <li>Pay for <strong>entire duration</strong> of parking</li>
//         <li>Report payment issues immediately</li>
//       </ul>

//       <h5 className="text-xl font-semibold mb-3 text-black">3.2 Parking Operators Must:</h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>Maintain sensor/LPR equipment</li>
//         <li>Honor pre-booked slots</li>
//         <li>Provide valid tax invoices</li>
//       </ul>
//     </div>

//     {/* Data Collection */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">4. Data Collection</h4>
//       <p className="text-black mb-4 text-lg">
//         We collect:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li><strong>Vehicle Data:</strong> License plate numbers, entry/exit times</li>
//         <li><strong>Payment Data:</strong> Transaction amounts, methods (no card details stored)</li>
//         <li><strong>Location Data:</strong> GPS coordinates for on-street parking</li>
//       </ul>
//       <p className="text-black text-lg">
//         <strong>LPR Data:</strong> Automatically deleted after 30 days unless required for disputes.
//       </p>
//     </div>

//     {/* Payments & Refunds */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">5. Payments & Refunds</h4>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>All payments are <strong>non-refundable</strong> after vehicle entry</li>
//         <li>Overpayments credited to user wallet for future use</li>
//         <li>Disputes must be raised within <strong>48 hours</strong></li>
//       </ul>
//     </div>

//     {/* Liability */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">6. Liability</h4>
//       <p className="text-black mb-4 text-lg">
//         Ajeevi is <strong>not responsible</strong> for:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>Vehicle damage/theft in parking facilities</li>
//         <li>Sensor malfunctions causing incorrect billing</li>
//         <li>Municipal parking violations/towing</li>
//       </ul>
//     </div>

//     {/* Governing Law */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">7. Governing Law</h4>
//       <p className="text-black text-lg">
//         These Terms are governed by Indian law. Disputes shall be resolved in Noida courts.
//       </p>
//     </div>

//     {/* Contact */}
//     <div>
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">8. Contact</h4>
//       <p className="text-black text-lg mb-2">
//         <strong>Ajeevi Technologies Pvt. Ltd.</strong><br />
//         Noida, Uttar Pradesh – 201301
//       </p>
//       <p className="text-black text-lg">
//         📧 <a href="mailto:parking-support@ajeevi.com" className="text-[#00D084] hover:underline">parking-support@ajeevi.com</a><br />
//         🌐 <a href="https://parkajv.ajeevi.in" target="_blank" rel="noopener noreferrer" className="text-[#00D084] hover:underline">parkajv.ajeevi.in</a>
//       </p>
//       <p>Note: Terms & Conditions is subjected to changed anytime.</p>
//     </div>
//   </div>
// </div>
//     </>
//   );
// };

// export default TermsConditions;



import { Link } from "react-router-dom";
import PageBanner from "./PageBanner";
import SectionHeader from "./SectionHeader";
import React from "react";
import {
  FaBarcode,
  FaMicrochip,
  FaChartLine,
  FaTv,
  FaRecycle,
} from "react-icons/fa";
import SocialMediaSidebar from "./SocialMediaSidebar";

const TermsConditions = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Terms & Conditions"
        breadcrumb={[
          { label: "Terms & Conditions", href: "/" },
          //   { label: "About Us" },
          //   { label: "Story" },
        ]}
      />

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Terms & Conditions @ AJEEVI"
          shareUrl="https://your-site.com/smart-waste"
        />
      </div>

    <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* Header Section */}
    <div className="mb-10">
      <h1 className="text-3xl font-bold text-black mb-2">Terms of Use</h1>
      <p className="text-lg text-black mb-4">
        <strong>Effective Date:</strong> 17-06-2025<br />
        <strong>Platform:</strong> Smart Pole<br />
        <strong>Operated By:</strong> Ajeevi Technologies Pvt. Ltd.
      </p>
    </div>

    {/* Welcome Statement */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">Welcome Statement</h4>
      <p className="text-black mb-4 text-lg">
        Welcome to <strong>Smart Pole</strong>, an IoT-enabled urban infrastructure platform developed by Ajeevi Technologies Pvt. Ltd. Our solution integrates <strong>smart lighting, environmental monitoring, public Wi-Fi, and surveillance</strong> to enhance city management and public safety.
      </p>
      <p className="text-black text-lg">
        These Terms govern your interaction with Smart Pole’s systems, including mobile/web apps, IoT sensors, and AI analytics. By using Smart Pole services, you agree to comply with these terms and all applicable laws.
      </p>
    </div>

    {/* Purpose of the Platform */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">1. Purpose of the Platform</h4>
      <p className="text-black mb-4 text-lg">
        Smart Pole is designed to:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Provide <strong>energy-efficient smart lighting</strong> with adaptive brightness</li>
        <li>Monitor <strong>air quality, noise levels, and weather conditions</strong> in real-time</li>
        <li>Offer <strong>free public Wi-Fi</strong> with secure authentication</li>
        <li>Support <strong>urban safety</strong> through AI-powered surveillance analytics</li>
        <li>Deliver <strong>data insights</strong> to municipal authorities for city planning</li>
      </ul>
    </div>

    {/* Eligibility and Access */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">2. Eligibility and Access</h4>
      
      <h5 className="text-xl font-semibold mb-3 text-black">2.1 Authorized Users</h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li><strong>Citizens:</strong> Accessing public Wi-Fi or environmental data</li>
        <li><strong>Municipal Staff:</strong> Managing lighting, sensors, or surveillance</li>
        <li><strong>Third-Party Contractors:</strong> Maintaining Smart Pole hardware</li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">2.2 Restricted Activities</h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>Tampering with IoT sensors or cameras</li>
        <li>Misusing Wi-Fi for illegal activities</li>
        <li>Unauthorized access to administrative systems</li>
      </ul>
    </div>

    {/* User Responsibilities */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">3. User Responsibilities</h4>
      
      <h5 className="text-xl font-semibold mb-3 text-black">3.1 Citizens Must:</h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Use public Wi-Fi <strong>responsibly and lawfully</strong></li>
        <li>Report malfunctioning sensors or lighting</li>
        <li>Avoid obstructing Smart Pole equipment</li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">3.2 Municipal Staff Must:</h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>Ensure <strong>data privacy</strong> when accessing surveillance feeds</li>
        <li>Maintain <strong>secure login credentials</strong> for admin portals</li>
        <li>Adhere to <strong>local regulations</strong> for data sharing</li>
      </ul>
    </div>

    {/* Data Collection */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">4. Data Collection</h4>
      <p className="text-black mb-4 text-lg">
        We collect:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li><strong>Environmental Data:</strong> Air quality (PM2.5, CO2), noise levels, temperature</li>
        <li><strong>Wi-Fi Usage Data:</strong> Connection duration, bandwidth (no personal browsing history)</li>
        <li><strong>Surveillance Data:</strong> Anonymized crowd analytics (faces blurred by default)</li>
      </ul>
      <p className="text-black text-lg">
        <strong>Camera Footage:</strong> Automatically deleted after 30 days unless required for investigations.
      </p>
    </div>

    {/* Service Availability */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">5. Service Availability</h4>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Smart Pole services are provided <strong>"as-is"</strong> without uptime guarantees</li>
        <li>Maintenance outages will be communicated via municipal channels</li>
        <li>Emergency features (e.g., surveillance) prioritized during disruptions</li>
      </ul>
    </div>

    {/* Liability */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">6. Liability</h4>
      <p className="text-black mb-4 text-lg">
        Ajeevi is <strong>not responsible</strong> for:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>Wi-Fi service interruptions or speed variations</li>
        <li>Environmental data inaccuracies due to sensor malfunctions</li>
        <li>Third-party misuse of public infrastructure</li>
      </ul>
    </div>

    {/* Governing Law */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">7. Governing Law</h4>
      <p className="text-black text-lg">
        These Terms are governed by Indian law. Disputes shall be resolved in Noida courts.
      </p>
    </div>

    {/* Contact */}
    <div>
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">8. Contact</h4>
      <p className="text-black text-lg mb-2">
        <strong>Ajeevi Technologies Pvt. Ltd.</strong><br />
        Noida, Uttar Pradesh – 201301
      </p>
      <p className="text-black text-lg">
        📧 <a href="mailto:smartpole-support@ajeevi.com" className="text-[#00D084] hover:underline">smartpole-support@ajeevi.com</a><br />
        🌐 <a href="https://smartpole.ajeevi.in" target="_blank" rel="noopener noreferrer" className="text-[#00D084] hover:underline">smartpole.ajeevi.in</a>
      </p>
      <p>Note: Terms & Conditions may be updated without prior notice.</p>
    </div>
  </div>
</div>
    </>
  );
};

export default TermsConditions;
